import type { Editor } from "@tiptap/core";

export type TextFormat = "paragraph" | "heading2" | "heading3" | "heading4";

export function normalizeBoldTextColor(html: string): string {
  const document = new DOMParser().parseFromString(html, "text/html");
  let hasColorOnBoldText = false;

  document.querySelectorAll("strong[style], b[style]").forEach((boldElement) => {
    const color = (boldElement as HTMLElement).style.color;
    if (!color) return;

    hasColorOnBoldText = true;
    (boldElement as HTMLElement).style.removeProperty("color");
    if (!boldElement.getAttribute("style")) {
      boldElement.removeAttribute("style");
    }

    const coloredText = document.createElement("span");
    coloredText.style.color = color;
    while (boldElement.firstChild) {
      coloredText.appendChild(boldElement.firstChild);
    }
    boldElement.appendChild(coloredText);
  });

  return hasColorOnBoldText ? document.body.innerHTML : html;
}

const headingLevels: Record<Exclude<TextFormat, "paragraph">, 2 | 3 | 4> = {
  heading2: 2,
  heading3: 3,
  heading4: 4,
};

export function applyTextFormat(editor: Editor, format: TextFormat) {
  const commandChain = editor
    .chain()
    .focus()
    .unsetAllMarks()
    .unsetTextAlign();

  if (format === "paragraph") {
    commandChain.setParagraph().run();
    return;
  }

  commandChain.setHeading({ level: headingLevels[format] }).run();
}